// extracted by mini-css-extract-plugin
export default {"empty-state-form__container":"styles_empty-state-form__container__7TOya","text__container":"styles_text__container__kyHn6"};